var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralLocationtype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.035,
    height: 41,
    viewBox: "0 0 36.035 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55227",
    "data-name": "Path 55227",
    d: "M53.966,335.224a1.227,1.227,0,0,0-1.129.553l-3.82,5.958-3.82-5.958a1.18,1.18,0,0,0-1.129-.553C36.117,336.065,31,338.78,31,342.167c0,4.685,9.273,7.207,18.018,7.207s18.018-2.522,18.018-7.207C67.035,338.78,61.918,336.065,53.966,335.224Z",
    transform: "translate(0 -308.374)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55228",
    "data-name": "Path 55228",
    d: "M274.018,342.22c0,4.685-9.273,7.207-18.018,7.207v-7.639l3.82-5.958a1.226,1.226,0,0,1,1.129-.553C268.9,336.118,274.018,338.832,274.018,342.22Z",
    transform: "translate(-206.982 -308.427)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55229",
    "data-name": "Path 55229",
    d: "M104.213,0A13.2,13.2,0,0,0,93.474,20.9L103.2,36.243a1.2,1.2,0,0,0,2.018,0L115,20.852A13.219,13.219,0,0,0,104.213,0Zm0,19.219a6.006,6.006,0,1,1,6.006-6.006A6.013,6.013,0,0,1,104.213,19.219Z",
    transform: "translate(-55.195)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55230",
    "data-name": "Path 55230",
    d: "M256,0V7.207h0a6.006,6.006,0,1,1,0,12.012h0V36.8a1.16,1.16,0,0,0,1.009-.552l9.778-15.391A13.219,13.219,0,0,0,256,0Z",
    transform: "translate(-206.982)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralLocationtype);
export default __webpack_public_path__ + "static/media/university-general-locationtype.48c49821ea33bcc6e8fe049704f6244b.svg";
export { ForwardRef as ReactComponent };